import { useSeo } from '@/lib/useSeo'
import { PageHeader, Prose } from '@/components/public/PageHeader'

export function Security() {
  useSeo({
    title: 'Security',
    description:
      'VICE security posture: row level security, CSP + security headers, OWASP ZAP baseline scans, npm audit, Dependabot, encrypted data in transit and at rest.',
  })
  return (
    <>
      <PageHeader
        eyebrow="Security"
        title="Defense in depth, from the first line of code."
        lede="VICE processes data that affects revenue and risk. Security is baseline, not bolt-on."
      />
      <Prose>
        <h2>Data protection</h2>
        <ul>
          <li>
            <strong>Row level security (RLS)</strong> enabled on every application table. No
            deny-by-default exceptions.
          </li>
          <li>
            <strong>Least privilege roles.</strong> Only authenticated USVI Agents access their own
            profile; admin reads require explicit role membership.
          </li>
          <li>
            <strong>Encryption in transit:</strong> TLS 1.2+ enforced end-to-end.
          </li>
          <li>
            <strong>Encryption at rest:</strong> AES-256.
          </li>
          <li>
            <strong>Secrets never ship to the client.</strong> Privileged credentials live only in
            server-side environments and CI secrets.
          </li>
        </ul>

        <h2>Application hardening</h2>
        <ul>
          <li>
            <strong>Strict Content Security Policy.</strong> Inline scripts restricted,
            third-party origins allow-listed.
          </li>
          <li>
            <strong>X-Frame-Options DENY</strong>, <strong>X-Content-Type-Options nosniff</strong>,
            and <strong>strict Referrer-Policy</strong> on every response.
          </li>
          <li>
            <strong>Email confirmation required</strong> before any sign-in succeeds.
          </li>
          <li>
            <strong>Password minimum 8 characters.</strong> Rate limits on sign-up, sign-in, and
            email sends.
          </li>
          <li>
            <strong>XSS sanitization</strong> of any user-generated content with{' '}
            <code>DOMPurify</code>.
          </li>
        </ul>

        <h2>Continuous assurance</h2>
        <ul>
          <li>
            <strong>OWASP ZAP baseline scan</strong> runs on every pull request.
          </li>
          <li>
            <strong>Dependency audits</strong> run on every build and weekly automated update PRs.
          </li>
          <li>
            <strong>Performance and best-practices checks</strong> run on every pull request.
          </li>
        </ul>

        <h2>Reporting a vulnerability</h2>
        <p>
          Found a security issue? Please <a href="/contact">contact us</a> with details. We
          acknowledge receipt within 2 business days and prioritize the fix.
        </p>
      </Prose>
    </>
  )
}
